import React from "react";
import { Popover, Box, Typography } from "@mui/material";

interface CustomPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: React.ReactNode;
  open: boolean;
  anchorOrigin?: {
    vertical: "top" | "center" | "bottom";
    horizontal: "left" | "center" | "right";
  };
  transformOrigin?: {
    vertical: "top" | "center" | "bottom";
    horizontal: "left" | "center" | "right";
  };
}

const PopoverCustom: React.FC<CustomPopoverProps> = ({
  anchorEl,
  onClose,
  children,
  open,
  anchorOrigin = { vertical: "bottom", horizontal: "center" },
  transformOrigin = { vertical: "top", horizontal: "center" },
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
    >
      <Box sx={{ display: "flex", p: 1, gap: 1 }}>{children}</Box>
    </Popover>
  );
};

export default PopoverCustom;
